import type { AuthContextType } from '@context/auth.context';
import type { ApiUser } from '@interfaces/api-user';
import { apiRequest, isResponse } from '@services/fetcher';
import type { LoaderFunction } from 'react-router-dom';

import { initUsers } from '@/newstore';

export const loader = (auth: AuthContextType) =>
  (async ({ request }) => {
    // TODO: temporary, users fetching need to be done in store, new fetcher needed
    const response = await apiRequest<ApiUser[]>(`${import.meta.env.VITE_API_URL}/organization/users`, auth, {
      signal: request.signal,
    });

    if (isResponse(response)) {
      return {
        status: response.status,
        statusText: response.statusText,
      } as Response;
    }

    if (response instanceof Error) {
      throw response;
    }

    initUsers(response);

    return response;
  }) satisfies LoaderFunction;
